import { useEffect } from 'react';

import { useAppDispatch } from 'features/app/hooks';
import { ensureCallStateReset } from 'features/call/call-base/store';

export const useCallStateResetBoundary = (enabled = true) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    dispatch(ensureCallStateReset());
  }, [dispatch, enabled]);
};
